"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[5615],{

/***/ 86889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vQ": () => (/* binding */ WhatsappConsent)
});

// UNUSED EXPORTS: GetUserConsent, UpdateUserConsent, WhatsappConsentModalContainer, whatsappConsentModalTestId

// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/components/WhatsappConsentModal/__generated__/WhatsAppConsentModal.gql.ts


const defaultOptions = {};
const UpdateUserConsentDocument = lib/* gql */.Ps`
    mutation UpdateUserConsent($input: UpdateUserInput!) {
  updateUser(input: $input) {
    person {
      whatsappConsent
    }
  }
}
    `;
function useUpdateUserConsentMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UpdateUserConsentDocument, options);
}
const GetUserConsentDocument = lib/* gql */.Ps`
    query GetUserConsent {
  myUser {
    person {
      whatsappConsent
    }
  }
}
    `;
function useGetUserConsentQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(GetUserConsentDocument, options);
}
function useGetUserConsentLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetUserConsentDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var launchdarkly_provider_dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./src/client/ui-default/index.ts
var ui_default = __webpack_require__(85538);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(91241);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
// EXTERNAL MODULE: ./src/ui/index.ts + 7 modules
var ui = __webpack_require__(31630);
// EXTERNAL MODULE: ./src/client/observability/uxAnalytics/index.ts + 5 modules
var uxAnalytics = __webpack_require__(62463);
;// CONCATENATED MODULE: ./src/client/components/WhatsappConsentModal/tracing.ts
var WhatsappConsentTracingSpans = /* @__PURE__ */ ((WhatsappConsentTracingSpans2) => {
  WhatsappConsentTracingSpans2["ROOT"] = "login";
  WhatsappConsentTracingSpans2["WHATSAPP_CONSENT_MODAL"] = "login.whatsappConsentModal";
  return WhatsappConsentTracingSpans2;
})(WhatsappConsentTracingSpans || {});
const WhatsappConsentTracingEvents = {
  ["login.whatsappConsentModal" /* WHATSAPP_CONSENT_MODAL */]: {
    CONTINUE: `${"login.whatsappConsentModal" /* WHATSAPP_CONSENT_MODAL */}.continue`,
    CANCEL: `${"login.whatsappConsentModal" /* WHATSAPP_CONSENT_MODAL */}.cancel`
  }
};

// EXTERNAL MODULE: ./src/client/ui-default/useUiDefault.ts + 1 modules
var useUiDefault = __webpack_require__(27753);
;// CONCATENATED MODULE: ./src/client/components/WhatsappConsentModal/WhatsAppConsentModal.tsx
















const componentName = "WhatsappConsentModal";
const whatsappConsentModalTestId = {
  container: componentName,
  checkBoxButton: `${componentName}.checkBoxButton`,
  continueButton: `${componentName}.continueButton`,
  cancelButton: `${componentName}.cancelButton`
};
const CheckBoxLabel = (0,styled/* default */.Z)("label")({
  cursor: "pointer",
  userSelect: "none"
});
const ConsentCheckbox = (0,styled/* default */.Z)(Checkbox/* default */.Z)({
  paddingLeft: 0,
  paddingRight: 0
});
function WhatsappConsentModalContainer({
  open,
  onCancel,
  onContinue
}) {
  const [consented, setConsented] = react.useState(false);
  const { addEventToSpan } = (0,uxAnalytics/* useTracing */.kz)();
  (0,uxAnalytics/* useMountSpan */.m0)(WhatsappConsentTracingSpans.WHATSAPP_CONSENT_MODAL);
  const CHECKBOX_ID = "whatsapp-consent-checkbox";
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open,
    onClose: onCancel,
    "data-testid": whatsappConsentModalTestId.container
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    pb: 0
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h4",
    style: { marginBottom: 0 }
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "user.consent.whatsapp.title",
    defaultMessage: "Whatsapp communication consent"
  }))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mb: 2,
    p: 0.5
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "user.consent.whatsapp.bodyMessage",
    defaultMessage: "May we have your consent to communicate with you through WhatsApp? This way, we can keep you updated on all the latest news and updates about Elephant OS."
  }))), /* @__PURE__ */ react.createElement(CheckBoxLabel, {
    htmlFor: CHECKBOX_ID
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 2
  }, /* @__PURE__ */ react.createElement(ConsentCheckbox, {
    autoFocus: true,
    color: "primary",
    id: CHECKBOX_ID,
    value: consented,
    onChange: (e) => {
      setConsented(e.target.checked);
    },
    inputProps: {
      "data-testid": whatsappConsentModalTestId.checkBoxButton
    }
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "user.consent.whatsapp.tickBox",
    defaultMessage: "By checking the box and clicking 'Continue', you'll receive timely updates and information about Elephant OS directly on WhatsApp."
  }))))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, {
    style: { display: "flex", gap: 8 }
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => {
      addEventToSpan(
        WhatsappConsentTracingEvents[WhatsappConsentTracingSpans.WHATSAPP_CONSENT_MODAL].CANCEL
      );
      onCancel();
    },
    "data-testid": whatsappConsentModalTestId.cancelButton
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "user.consent.whatsapp.denyBtn",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "primary",
    onClick: () => onContinue(consented),
    "data-testid": whatsappConsentModalTestId.continueButton,
    disabled: !consented
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "user.consent.whatsapp.confirmationBtn",
    defaultMessage: "Continue"
  }))));
}
const UpdateUserConsent = lib/* gql */.Ps`
  mutation UpdateUserConsent($input: UpdateUserInput!) {
    updateUser(input: $input) {
      person {
        whatsappConsent
      }
    }
  }
`;
const GetUserConsent = lib/* gql */.Ps`
  query GetUserConsent {
    myUser {
      person {
        whatsappConsent
      }
    }
  }
`;
const uiDefaultVariables = {
  args: {
    name: "whatsappConsentModal",
    namespace: "elephant-web",
    scope: base_gql/* DefaultScope.User */.Vn.User
  }
};
const WhatsappConsent = () => {
  var _a, _b, _c;
  const { userId } = (0,dist_module/* useUserContext */.SE)();
  const whatsappConsentFF = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(featureFlags/* featureFlags.user.whatsappConsent */.VH.user.whatsappConsent);
  const userWhatsappConsent = useGetUserConsentQuery();
  const {
    value: uiDefaultValue,
    loading: uiDefaultValueLoading,
    save
  } = (0,ui_default/* useUiDefault */.k)({
    ...uiDefaultVariables.args,
    defaultValue: { hasSeen: true }
  });
  const dataLoaded = !userWhatsappConsent.loading && !uiDefaultValueLoading;
  const userHasGivenConsent = !!((_c = (_b = (_a = userWhatsappConsent.data) == null ? void 0 : _a.myUser) == null ? void 0 : _b.person) == null ? void 0 : _c.whatsappConsent);
  const hasSeenModal = uiDefaultValue == null ? void 0 : uiDefaultValue.hasSeen;
  const [mutateUserConsent] = useUpdateUserConsentMutation();
  const shouldShowModal = whatsappConsentFF && dataLoaded && !(userHasGivenConsent || hasSeenModal);
  const saveHasSeen = () => {
    save(
      { hasSeen: true },
      {
        optimisticResponse: {
          upsertUiDefault: {
            id: "optimisticResponse_cache",
            ...uiDefaultVariables.args,
            value: { hasSeen: true }
          }
        },
        update: (cache, { data }) => {
          cache.writeQuery({
            query: useUiDefault/* QUERY */.Q,
            variables: uiDefaultVariables,
            data: { UiDefault: data.upsertUiDefault }
          });
        }
      }
    );
  };
  const onCancel = saveHasSeen;
  const onAcceptedConsent = (hasGivenConsent) => {
    mutateUserConsent({
      variables: {
        input: {
          _id: userId,
          person: {
            whatsappConsent: hasGivenConsent
          }
        }
      },
      update: (cache, res) => {
        var _a2, _b2, _c2;
        if ((_c2 = (_b2 = (_a2 = res.data) == null ? void 0 : _a2.updateUser) == null ? void 0 : _b2.person) == null ? void 0 : _c2.whatsappConsent) {
          cache.writeQuery({
            query: GetUserConsent,
            data: {
              myUser: {
                person: {
                  whatsappConsent: hasGivenConsent
                }
              }
            }
          });
        }
      }
    });
    saveHasSeen();
  };
  return /* @__PURE__ */ react.createElement(WhatsappConsentModalContainer, {
    open: shouldShowModal,
    onCancel,
    onContinue: onAcceptedConsent
  });
};


/***/ }),

/***/ 49444:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dev_tools)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+devtools-provider@1.2.7_bvw6vv4lh73pin7gkzmur3rnre/node_modules/@elephant-healthcare/devtools-provider/dist/module.js
var dist_module = __webpack_require__(37671);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+config-provider@2.1.0_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/config-provider/dist/module.js
var config_provider_dist_module = __webpack_require__(23198);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./src/client/utils/useUser.ts
var useUser = __webpack_require__(91019);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var user_context_provider_dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./src/client/utils/useUserLanguage.jsx
var useUserLanguage = __webpack_require__(55541);
;// CONCATENATED MODULE: ./src/client/dev-tools/DevTools.tsx







function useSetLanguage() {
  var _a;
  const setUser = (_a = react.useContext(user_context_provider_dist_module/* UserContext */.St)) == null ? void 0 : _a.setUser;
  return react.useCallback(
    (language) => {
      if (!setUser)
        return;
      setUser((oldUser) => ({ ...oldUser, language }));
    },
    [setUser]
  );
}
const DevTools = () => {
  var _a;
  const { flags, updateFlags } = (0,featureFlags/* useFeatureFlagContext */.dG)();
  const config = (0,config_provider_dist_module/* useConfig */.ZR)();
  const user = (0,useUser/* useLazyUser */.x)();
  const setLanguage = useSetLanguage();
  return /* @__PURE__ */ react.createElement(dist_module/* DevToolsProvider */.kc, {
    appVersion: "4.5.3",
    user: user && {
      ...user,
      language: (_a = user.language) != null ? _a : useUserLanguage/* DEFAULT_LANGUAGE */.k$
    },
    setUserLanguage: setLanguage,
    config,
    featureFlags: flags,
    onFeatureFlagChange: updateFlags
  });
};
/* harmony default export */ const dev_tools_DevTools = (DevTools);

;// CONCATENATED MODULE: ./src/client/dev-tools/index.tsx



const client_dev_tools_DevTools = () => {
  if ((0,dist_module/* devToolsEnabled */.ub)()) {
    return /* @__PURE__ */ react.createElement(dev_tools_DevTools, null);
  }
  return null;
};
/* harmony default export */ const dev_tools = (client_dev_tools_DevTools);


/***/ }),

/***/ 41054:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52018);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61800);
/* harmony import */ var _material_ui_icons_RadioButtonChecked__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27766);
/* harmony import */ var _material_ui_icons_RadioButtonUnchecked__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65783);
/* harmony import */ var _components_HTMLControls_Fields_Label_Label__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19895);
/* harmony import */ var _components_HTMLControls_Fields_Radio_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21498);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21235);
/* harmony import */ var _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10353);









const RHFYesNoRadioInput = (props) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const { setValue, watch } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)();
  const {
    classes = {},
    label,
    translation,
    required,
    disabled,
    name,
    dataTestId,
    inline = false,
    noFirst = false
  } = props;
  const value = watch(name);
  const controlTrue = value === true ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_icons_RadioButtonChecked__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_icons_RadioButtonUnchecked__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null);
  const controlFalse = value === false ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_icons_RadioButtonChecked__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_icons_RadioButtonUnchecked__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null);
  const makeTrue = () => {
    setValue(name, true);
  };
  const makeFalse = () => {
    setValue(name, false);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: `${classes.container} ${inline ? "inline" : ""}`,
    "data-testid": dataTestId
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_HTMLControls_Fields_Label_Label__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    className: `${inline ? "inline-label" : ""}`,
    name,
    label,
    required,
    translation,
    style: { maxWidth: "347px" }
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: `${classes.group} ${noFirst ? "no-first" : ""}`,
    role: "radiogroup",
    "aria-labelledby": name
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    className: classes.radio,
    onClick: makeTrue,
    color: "primary",
    variant: "outlined",
    "data-testid": `${dataTestId}-1`,
    startIcon: controlTrue,
    disabled,
    value: value === true ? "checked" : "",
    "aria-checked": value === true ? "true" : "false",
    role: "radio"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    variant: "body1"
  }, formatMessage({
    id: "yesNoRadioInput.yes",
    defaultMessage: "Yes"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    className: classes.radio,
    variant: "outlined",
    color: "primary",
    onClick: makeFalse,
    "data-testid": `${dataTestId}-0`,
    startIcon: controlFalse,
    disabled,
    value: value === false ? "checked" : "",
    "aria-checked": value === false ? "true" : "false",
    role: "radio"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    variant: "body1"
  }, formatMessage({ id: "yesNoRadioInput.no", defaultMessage: "No" })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_8__/* .withStyles */ .D)(
  _components_HTMLControls_Fields_Radio_styles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
)(RHFYesNoRadioInput));


/***/ }),

/***/ 86567:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21235);
/* harmony import */ var elephant_web_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31630);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98806);




const RHFSearchField = ({ name, ...props }) => {
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const {
    control,
    setValue,
    getValues,
    register,
    formState: { errors, touchedFields }
  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)();
  const defaultValue = getValues(name);
  const value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useWatch */ .qo)({ control, name });
  const touched = (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(name.split("."), touchedFields);
  const error = (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(name.split("."), errors);
  const errStr = touched ? error == null ? void 0 : error.message : null;
  const { ref, ...field } = register(name);
  const handleClear = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setValue(name, "");
    inputRef.current.focus();
  }, [name, setValue]);
  const handleRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (e) => {
      ref(e);
      inputRef.current = e;
    },
    [ref]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(elephant_web_ui__WEBPACK_IMPORTED_MODULE_1__/* .SearchField */ .Um, {
    ...props,
    ...field,
    defaultValue,
    error: errStr,
    value,
    onClear: handleClear,
    ref: handleRef
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RHFSearchField);


/***/ }),

/***/ 73306:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52018);
/* harmony import */ var _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29054);
/* harmony import */ var elephant_web_client_observability_uxAnalytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62463);




const TextFieldWrapper = ({
  analyticsName,
  ...props
}) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const { startSpan, endSpan } = (0,elephant_web_client_observability_uxAnalytics__WEBPACK_IMPORTED_MODULE_2__/* .useTracing */ .kz)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_1__/* .TextField */ .nv, {
    ...props,
    ...analyticsName && {
      onFocus: (...args) => {
        var _a;
        startSpan(analyticsName);
        (_a = props.onFocus) == null ? void 0 : _a.call(props, ...args);
      },
      onBlur: (...args) => {
        var _a;
        endSpan(analyticsName);
        (_a = props.onBlur) == null ? void 0 : _a.call(props, ...args);
      }
    },
    clearButtonTitle: formatMessage({
      id: "textField.clear",
      defaultMessage: "Clear"
    })
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TextFieldWrapper);


/***/ }),

/***/ 95674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__.Mt),
/* harmony export */   "Cm": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__.jI),
/* harmony export */   "DM": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__.mg),
/* harmony export */   "Fl": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__.F2),
/* harmony export */   "M5": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__.OT),
/* harmony export */   "au": () => (/* reexport safe */ _TextField__WEBPACK_IMPORTED_MODULE_1__.Z),
/* harmony export */   "lY": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__.ji),
/* harmony export */   "ov": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__.gu),
/* harmony export */   "r": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__.Kx)
/* harmony export */ });
/* harmony import */ var _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29054);
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73306);
/* harmony import */ var _SearchField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86567);





/***/ }),

/***/ 86347:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": () => (/* reexport safe */ _fields__WEBPACK_IMPORTED_MODULE_0__.C5),
/* harmony export */   "DM": () => (/* reexport safe */ _fields__WEBPACK_IMPORTED_MODULE_0__.DM),
/* harmony export */   "Qz": () => (/* reexport safe */ _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_1__.Mm),
/* harmony export */   "au": () => (/* reexport safe */ _fields__WEBPACK_IMPORTED_MODULE_0__.au),
/* harmony export */   "lY": () => (/* reexport safe */ _fields__WEBPACK_IMPORTED_MODULE_0__.lY),
/* harmony export */   "ov": () => (/* reexport safe */ _fields__WEBPACK_IMPORTED_MODULE_0__.ov),
/* harmony export */   "r": () => (/* reexport safe */ _fields__WEBPACK_IMPORTED_MODULE_0__.r)
/* harmony export */ });
/* harmony import */ var _fields__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95674);
/* harmony import */ var _elephant_healthcare_react_hook_form_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29054);




/***/ }),

/***/ 78802:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52018);
/* harmony import */ var _elephant_healthcare_mui_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34948);



const TextFieldWrapper = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(
  (props, ref) => {
    const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_input__WEBPACK_IMPORTED_MODULE_1__/* .TextField */ .nv, {
      ...props,
      ref,
      clearButtonTitle: formatMessage({
        id: "textField.clear",
        defaultMessage: "Clear"
      })
    });
  }
);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TextFieldWrapper);


/***/ }),

/***/ 35831:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));


/***/ }),

/***/ 21265:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85961);
/* harmony import */ var elephant_web_client_utils_validationPack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43576);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31160);



const filterUndefined = (v) => v !== void 0;
(0,yup__WEBPACK_IMPORTED_MODULE_0__.setLocale)({
  mixed: {
    required: _messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.mixed.required */ .K1.mixed.required,
    notType: function notType(ref) {
      switch (ref.type) {
        case "number":
          return _messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.number["default"] */ .K1.number["default"];
        default:
          return "Invalid";
      }
    }
  },
  number: {
    positive: _messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.number.positive */ .K1.number.positive,
    integer: _messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.number.integer */ .K1.number.integer
  },
  string: {
    email: _messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.string.email */ .K1.string.email,
    min: ({ min }) => ({
      ..._messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.string.min */ .K1.string.min,
      values: {
        min
      }
    }),
    max: ({ max }) => ({
      ..._messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.string.max */ .K1.string.max,
      values: {
        max
      }
    })
  }
});
(0,yup__WEBPACK_IMPORTED_MODULE_0__.addMethod)(yup__WEBPACK_IMPORTED_MODULE_0__.string, "password", function password(message) {
  const minLength = 6;
  return this.test("password-valid", message, function passwordTest(value) {
    if (!value) {
      return true;
    }
    if (value.length < minLength) {
      return this.createError({
        message: {
          ..._messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.string.min */ .K1.string.min,
          values: { min: minLength }
        }
      });
    }
    if (!elephant_web_client_utils_validationPack__WEBPACK_IMPORTED_MODULE_1__/* .specialCharRegex.test */ .qr.test(value)) {
      return this.createError({
        message: _messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.string.specialChar */ .K1.string.specialChar
      });
    }
    if (!elephant_web_client_utils_validationPack__WEBPACK_IMPORTED_MODULE_1__/* .singleNumberMinRegex.test */ .S$.test(value)) {
      return this.createError({
        message: _messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.string.singleNumber */ .K1.string.singleNumber
      });
    }
    if (!elephant_web_client_utils_validationPack__WEBPACK_IMPORTED_MODULE_1__/* .lowercaseCharRegex.test */ .$_.test(value)) {
      return this.createError({
        message: _messages__WEBPACK_IMPORTED_MODULE_2__/* .validationMessages.string.lowercaseChar */ .K1.string.lowercaseChar
      });
    }
    return true;
  });
});
(0,yup__WEBPACK_IMPORTED_MODULE_0__.addMethod)(yup__WEBPACK_IMPORTED_MODULE_0__.array, "unique", function unique(message, mapper = (a) => a) {
  return this.test("unique", message, (list) => {
    const mappedList = list.map(mapper).filter(filterUndefined);
    return mappedList.length === new Set(mappedList).size;
  });
});


/***/ }),

/***/ 31160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K1": () => (/* binding */ validationMessages)
/* harmony export */ });
/* unused harmony exports requiredMessage, emailMessage, stringMinMessage, stringMaxMessage, stringLengthMessage, specialCharMessage, singleNumberMessage, lowercaseCharMessage, positiveMessage, greaterThanZeroMessage, integerMessage, numberMessage, validDateMessage, validDobMessage */
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11313);

const requiredMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.mixed.required",
  defaultMessage: "Required"
});
const emailMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.string.email",
  defaultMessage: "Invalid email address"
});
const stringMinMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.string.min",
  defaultMessage: "Must be at least {min} {min, plural, one {character} other {characters}}"
});
const stringMaxMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.string.max",
  defaultMessage: "Cannot be more than {max} {max, plural, one {character} other {characters}}"
});
const stringLengthMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.string.length",
  defaultMessage: "Must be {length} {length, plural, one {character} other {characters}}"
});
const specialCharMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.password.specialChar",
  defaultMessage: "Must contain at least one special character"
});
const singleNumberMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.password.number",
  defaultMessage: "Must contain at least one number"
});
const lowercaseCharMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.password.lowercase",
  defaultMessage: "Must contain at least one lowercase"
});
const positiveMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.number.positive",
  defaultMessage: "Must be positive"
});
const greaterThanZeroMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.number.greaterThanZero",
  defaultMessage: "Must be greater than zero"
});
const integerMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.number.integer",
  defaultMessage: "Must be a whole number"
});
const numberMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.number.default",
  defaultMessage: "Must be a valid number"
});
const validDateMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.date.valid",
  defaultMessage: "Must be a valid date"
});
const validDobMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "form.validation.date.dob",
  defaultMessage: "Must be a valid date of birth"
});
const validationMessages = {
  mixed: {
    required: requiredMessage
  },
  number: {
    integer: integerMessage,
    positive: positiveMessage,
    greaterThanZero: greaterThanZeroMessage,
    default: numberMessage
  },
  string: {
    email: emailMessage,
    lowercaseChar: lowercaseCharMessage,
    min: stringMinMessage,
    max: stringMaxMessage,
    length: stringLengthMessage,
    singleNumber: singleNumberMessage,
    specialChar: specialCharMessage
  },
  date: {
    valid: validDateMessage,
    dob: validDobMessage
  }
};


/***/ })

}]);